import CampaignPage from "@/modules/campaign/campaign-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_layout/campaign")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <CampaignPage />
    </div>
  );
}
